import { createSlice } from '@reduxjs/toolkit';

export interface ModulesState {
  administrationSettings: boolean;
  bookkeeping: boolean;
  frontOffice: boolean;
  housekeepingManagement: boolean;
  humanResources: boolean;
  inventory: boolean;
  maintenanceAndEngineering: boolean;
  payroll: boolean;
  pointOfSale: boolean;
  profilesManagement: boolean;
  reports: boolean;
  revenueManagement: boolean;
  salesAndBanquet: boolean;
  timekeeping: boolean;
  usersManagement: boolean;
  moduleSelector: boolean;
}

export interface ModuleGuideState {
  value: ModulesState;
  user: string | null | undefined;
}

export type guideTitleType =
  | 'administrationSettings'
  | 'bookkeeping'
  | 'frontOffice'
  | 'housekeepingManagement'
  | 'humanResources'
  | 'inventory'
  | 'maintenanceAndEngineering'
  | 'payroll'
  | 'pointOfSale'
  | 'profilesManagement'
  | 'reports'
  | 'revenueManagement'
  | 'salesAndBanquet'
  | 'timekeeping'
  | 'usersManagement'
  | 'moduleSelector'
  | null;

const initialState: ModuleGuideState = {
  value: {
    administrationSettings: true,
    bookkeeping: true,
    frontOffice: true,
    housekeepingManagement: true,
    humanResources: true,
    inventory: true,
    maintenanceAndEngineering: true,
    payroll: true,
    pointOfSale: true,
    profilesManagement: true,
    reports: true,
    revenueManagement: true,
    salesAndBanquet: true,
    timekeeping: true,
    usersManagement: true,
    moduleSelector: true,
  },
  user: null,
};

export const GuideSlice = createSlice({
  name: 'guide',
  initialState,
  reducers: {
    setGuideState: (state, action) => {
      state.value = { ...state.value, ...action.payload };
    },
    resetGuide: (state, _action) => {
      state.value = initialState.value;
    },
    setGuideUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export default GuideSlice.reducer;

export const { setGuideState, resetGuide, setGuideUser } = GuideSlice.actions;
